import { GET, POST, DELETE } from './Httpr.js';
const prefix = "events/";


export async function getPreviewEvents(){
    let rsp = await GET(prefix + 'getPreview');

    return rsp;
}

export async function getAllEvents(){
    let rsp = await GET(prefix + 'getAll');

    return rsp;
}

export async function createPersonalEvent(request){
    let url = prefix + 'createPersonalEvent';
    let rsp = await POST(url, request);

    return rsp;
}

export async function deletePersonalEvent(request){
    let url = prefix + 'deletePersonalEvent';
    let requestData = {
        id_event: request
    };

    let rsp = await DELETE(url, requestData);

    return rsp;
}

